import { URL_PARAMS } from "./const/URL_PARAMS";
import { createSimpleLogger } from "./logger";
import { getValidatedParamValue } from "./validateAndFormatParamValue";
function utf8_to_b64(str) {
    return window.btoa(unescape(encodeURIComponent(str)));
}
function b64_to_utf8(str) {
    return decodeURIComponent(escape(window.atob(str)));
}
export const getSearchParamValues = (shouldEncode = true) => {
    const logger = createSimpleLogger("PARSE SEARCH PARAMS");
    const allSearchParams = new URLSearchParams(window.location.search);
    logger.log("raw", window.location.search);
    const isEncoded = allSearchParams.get("capture_data");
    if (isEncoded) {
        logger.log("Parsing encoded data");
        try {
            const res = JSON.parse(b64_to_utf8(isEncoded));
            const parsed = Object.entries(res).reduce((res, [key, value]) => {
                const validated = getValidatedParamValue(key, value);
                if (validated) {
                    return Object.assign(Object.assign({}, res), { [key]: validated });
                }
                return res;
            }, {});
            logger.log("Parsed values", parsed);
            return parsed;
        }
        catch (_a) {
            return {};
        }
    }
    logger.log("Parsing fresh data");
    const result = URL_PARAMS.reduce((res, key) => {
        const value = allSearchParams.get(key);
        allSearchParams.delete(key);
        const validated = getValidatedParamValue(key, value);
        if (validated !== null) {
            return Object.assign(Object.assign({}, res), { [key]: validated });
        }
        return res;
    }, {});
    if (shouldEncode && Object.keys(result).length > 0) {
        try {
            const encoded = utf8_to_b64(JSON.stringify(result));
            allSearchParams.set("capture_data", encoded);
            window.location.search = allSearchParams.toString();
        }
        catch (_b) { }
    }
    logger.log("Parsed values", result);
    return result;
};
